<nz-table class="full-width" #sessionTable [nzData]="sessionList ?? []" [nzPaginationType]="'small'" [nzPageSize]="8">
  <thead>
    <tr>
      <th [nzWidth]="'140px'">Time</th>
      <th>Sales Rep</th>
      <th>Customer</th>
      <th>Scenario</th>
      <th>Score</th>
      <th [nzWidth]="'150px'">Status</th>
      <th></th>
    </tr>
  </thead>
  <tbody>
    @for (data of sessionTable.data; track data.id; let i = $index) {
      <tr>
        <td>{{ data.createdTime | toLocaleFormat: 'ff' }}</td>
        <td><app-board-icon-title [board]="data.createdBy"></app-board-icon-title></td>
        <td>
          <div class="horizontal">
            <img class="portrait" [src]="data.subData.resume?.subData?.content?.portraitImageUrl" />
            {{ data.subData.resume?.subData?.content?.firstName }}
          </div>
        </td>
        <td>{{ data.subData.template?.title ?? '' }}</td>
        <td>{{ data.subData.score }}</td>
        <td>
          <div class="horizontal seperate">
            @if (data.status === SessionStatus.done) {
              <nz-tag nzColor="success">
                <span nz-icon nzType="check-circle"></span>
                <span>Finished</span>
              </nz-tag>
            } @else if (isOngoing(data)) {
              <div class="vertical">
                <nz-tag nzColor="error">
                  <span nz-icon nzType="close-circle"></span>
                  <span>Exit Early</span>
                </nz-tag>
                <!-- <div class="horizontal remaining-time">
                  <span nz-icon style="font-size: 16px" class="material-symbols-rounded">timelapse</span>
                  <span>{{ getLeftMinutes(data) | number: '1.0-0' }} mins Left</span>
                </div>

                <button nz-button nzType="primary" [nzSize]="'default'" (click)="onContinueSessionClick(data)">
                  <span>Continue</span>
                </button> -->
              </div>
            } @else {
              <nz-tag nzColor="success">
                <span nz-icon nzType="clock-circle"></span>
                <span>Not Start</span>
              </nz-tag>
            }
          </div>
        </td>
        <td>
          <div class="horizontal">
            @if (data.status === SessionStatus.done) {
              <button
                [matTooltip]="'Report Details'"
                nz-button
                nzType="primary"
                [nzSize]="'default'"
                (click)="onViewDetailsClick(data)"
              >
                <span nz-icon style="font-size: 18px" class="material-symbols-rounded">description</span>
                Report
              </button>
            }

            <button
              nz-button
              nzType="text"
              [nzDanger]="true"
              [nzSize]="'small'"
              [matTooltip]="'Remove'"
              nz-popconfirm
              nzOkText="Remove"
              nzPopconfirmTitle="Are you sure you want to remove this practice?"
              nzPopconfirmPlacement="bottom"
              (nzOnConfirm)="onDeleteSessionClick(data)"
            >
              <span nz-icon style="font-size: 16px" class="material-symbols-rounded">delete_forever</span>
            </button>
          </div>
        </td>
      </tr>
    }
  </tbody>
</nz-table>
